import React from "react";
import Measure from "react-measure";
import { Grid } from "@material-ui/core";
import { PAGES } from "../../../navigation/types/pages.constant";
import { BriefType } from "../../../../constants/types";
import { BackButton } from "../../../../components/form-controls/button/back-button/back-button.component";
import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";
import { BriefHeaderProps } from "./brief-header.props";
import { BriefHeaderActions } from "./brief-header-actions/brief-header-actions.component";
import { BriefHeaderData } from "./brief-header-data/brief-header-data.component";
import { BreadcrumbButtonProps } from "../../../../components/breadcrumbs/breadcrumbs-button/breadcrumbs-button.props";
import { Breadcrumbs } from "../../../../components/breadcrumbs/breadcrumbs.component";
import { HeaderGlobals } from "../../../../components/headers/header-globals/header-globals.component";
import {
  LeftCol,
  MainWrapper,
  RightCol,
} from "../../../../components/headers/header/header.styles";
import { usePageTitle } from "../../../navigation/types/pages.functions";
import { BasicResourceType } from "../../../../types/resources/resources.enums";

export const BriefHeader = withShowIf((props: BriefHeaderProps) => {
  const isSaveDisabled = props.isSaveDisabled || !props.loaded || props.currentTabValue !== 0;

  const showHeader = () => !props.hasErrors;
  const showHeaderActions = () => showHeader() && !!props.formRef;

  const breadcrumbs = () => {
    const breadcrumbs: BreadcrumbButtonProps[] = [];

    switch (props.briefType) {
      case BriefType.EXECUTION_BRIEF:
        if (props.breadcrumbInfo?.parentName) {
          breadcrumbs.push({
            title: props.breadcrumbInfo.parentName,
            url: `${PAGES.CAMPAIGN_BRIEF.URL}/${props.breadcrumbInfo.parentId}`,
          });
        }

        return breadcrumbs;

      case BriefType.WORK_ORDER:
        if (props.breadcrumbInfo?.grandparentName) {
          breadcrumbs.push({
            title: props.breadcrumbInfo.grandparentName,
            url: `${PAGES.CAMPAIGN_BRIEF.URL}/${props.breadcrumbInfo.grandparentId}`,
          });
        }

        if (props.breadcrumbInfo?.parentName) {
          breadcrumbs.push({
            title: props.breadcrumbInfo.parentName,
            url: `${PAGES.EXECUTION_BRIEF.URL}/${props.breadcrumbInfo.parentId}`,
          });
        }

        return breadcrumbs;

      default:
        return breadcrumbs;
    }
  };

  switch (props.briefType) {
    case BriefType.CAMPAIGN_BRIEF:
      usePageTitle(`${PAGES.CAMPAIGN_BRIEFS.TITLE} - ${props.briefName}`);
      break;
    case BriefType.EXECUTION_BRIEF:
      usePageTitle(`${PAGES.EXECUTION_BRIEFS_LIST.TITLE} - ${props.briefName}`);
      break;
    case BriefType.WORK_ORDER:
      usePageTitle(`${PAGES.WORK_ORDERS_LIST.TITLE} - ${props.briefName}`);
      break;
    case BasicResourceType.Flyer:
      usePageTitle(`${PAGES.FLYERS.TITLE} - ${props.briefName}`);
      break;
  }

  return (
    <Measure
      bounds
      onResize={(contentRect: any) => {
        props.setHeaderHeight(contentRect?.bounds?.height ?? 0);
      }}
    >
      {({ measureRef }) => (
        <MainWrapper ref={measureRef}>
          <Grid>
            <Breadcrumbs breadcrumbs={breadcrumbs()} />
            <LeftCol>
              <BackButton />
              <BriefHeaderData
                briefId={props.briefId}
                briefName={props.briefName}
                briefOwner={props.briefOwner}
                briefTemplate={props.briefTemplate}
                briefType={props.briefType}
                onChangeName={props.onChangeName}
                showIf={showHeader()}
                status={props.status}
                updatedTime={props.updatedTime}
              />
            </LeftCol>
          </Grid>
          <RightCol>
            <BriefHeaderActions
              extraActions={props.extraActions ?? []}
              formRef={props.formRef}
              isSaveDisabled={isSaveDisabled}
              loaded={props.loaded}
              showIf={showHeaderActions()}
              onSubmit={props.onSubmit}
            />
            <HeaderGlobals />
          </RightCol>
        </MainWrapper>
      )}
    </Measure>
  );
});
